
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 252 205"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.005 4.975v6.403H5a5 5 0 00-5 5v158.26a5 5 0 005 5h14.258v-.092c.266.045.539.068.817.07 27.785.166 78.066 4.897 95.725 23.086 1.047 1.078 2.453 1.77 3.955 1.77h12.192c1.663 0 3.189-.843 4.339-2.045 8.297-8.674 35.91-22.564 94.874-22.801.365-.002.72-.042 1.063-.116v.128h14.259a5 5 0 005-5V16.378a5 5 0 00-5-5h-10.26V4.965c0-2.761-2.294-4.993-5.055-4.965-63.984.65-90.15 13.593-100.02 21.175-2.871 2.205-8.202 2.417-11.148.313C109.463 13.964 82.145.688 20.054.002c-2.762-.03-5.05 2.211-5.05 4.973zm9.63 4.882v141.14c74.752 0 94.517 21.032 94.517 21.032H120V35.19h-.34S110.03 9.85 24.633 9.85zM131.684 35h.313v136.88c2.305-1.895 27.375-21.136 94.594-21.136V10.104c-77.342 0-93.44 22.54-94.908 24.89z","clip-rule":"evenodd","fill-rule":"evenodd"}})])
          )
        }
      }
    